import { ScrollView as TamaguiScrollView } from '@mythical/ui'

export const ScrollView = TamaguiScrollView
